import styled from 'styled-components';

export enum Size {
  S = '46px',
  M = '60px',
  L = '100px',
}

export default function SpinnerOverlay({ margin, size = Size.L, wholePage = true }: { margin?: string, size?: Size, wholePage?: boolean }) {
  return (
    <OverlayContainer fixed={wholePage}>
      <Spinner
        alt="loading"
        margin={margin}
        size={size}
        src="https://images.hu-production.be/static/img/green-spinner.svg"
      />
    </OverlayContainer>
  );
}

const OverlayContainer = styled.div<{ fixed?: boolean }>`
  position: ${props => props.fixed ? 'fixed' : 'absolute'};
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 10;
`;

const Spinner = styled.img<{ margin?: string, size: string }>`
  width: ${props => props.size};
  height: ${props => props.size};
  margin: ${props => props.margin ? props.margin : '20% auto'};
`;
